@if (textPosition !== 'top') {
  <div class="container" [ngClass]="{ opposite: textPosition === 'left' }">
    <ng-container [ngTemplateOutlet]="progressBar"></ng-container>
    @if (type === 'percent') {
      <span class="score" [ngClass]="{ 'align-right': textPosition === 'right' }">
        {{ _current / (length || 1) | percent }}
      </span>
    }
    @if (type === 'fraction') {
      <span class="score"> {{ _current }}/{{ length }} </span>
    }
  </div>
} @else {
  <div class="container">
    <div class="top-text">
      <ng-container [ngTemplateOutlet]="topText || defaultTopText"> </ng-container>
    </div>
  </div>
  <ng-container [ngTemplateOutlet]="progressBar"></ng-container>
}

<ng-template #progressBar>
  <div
    class="progress-bar"
    [style.maxWidth]="maxBarWidth ? maxBarWidth + 'px' : 'none'"
    [style.width]="maxBarWidth ? maxBarWidth + 'px' : 'none'"
    [style.maxHeight]="maxBarHeight ? maxBarHeight + 'px' : 'none'"
    [style.height]="maxBarHeight ? maxBarHeight + 'px' : 'none'"
    [ngClass]="{ border: withBorder }"
  >
    <div #progress class="progress" [ngStyle]="progressColor && { backgroundColor: progressColor }"></div>
  </div>
</ng-template>

<ng-template #defaultTopText>
  @if (type === 'percent') {
    <span class="score">
      {{ _current / length | percent }}
    </span>
  }
  @if (type === 'fraction') {
    <span class="score"> {{ _current }}/{{ length }} </span>
  }
</ng-template>
